import { injectable } from 'inversify';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { EventAggregationService } from '@/platform/EventAggregationService';
import { SearchResultsReadyEvent } from '@/platform/events/SearchResultsReadyEvent';
import { SeoMetaDataPrerenderRefreshCompletedEvent } from '@/platform/events/SeoMetaDataPrerenderRefreshCompletedEvent';

type SubscribedTo = SearchResultsReadyEvent | SeoMetaDataPrerenderRefreshCompletedEvent;

@injectable()
export class Prerender implements ISubscriber<SubscribedTo> {

	private readonly eventAggregationService: EventAggregationService;

	private searchResultsReady = false;
	private seoMetaDataPrerenderReady = false;
	private shouldUpdatePrerender = true;
	

	public constructor(eventAggregationService: EventAggregationService) {
		this.eventAggregationService = eventAggregationService;

		this.eventAggregationService.subscribeTo(SearchResultsReadyEvent.EventType, this, true);
		this.eventAggregationService.subscribeTo(SeoMetaDataPrerenderRefreshCompletedEvent.EventType, this, true);

		this.initializePrerenderFlag();
	}

	public notify(event: SubscribedTo): void {

		if (!this.shouldUpdatePrerender) {
			return;
		}

		if (SearchResultsReadyEvent.is(event)) {
			this.searchResultsReady = true;
		}

		if (SeoMetaDataPrerenderRefreshCompletedEvent.is(event)) {
			this.seoMetaDataPrerenderReady = true;
		}

		if (this.searchResultsReady && this.seoMetaDataPrerenderReady) {
			this.setPrerenderReady();
		}
	}

	private initializePrerenderFlag(): void {
		window.prerenderReady = false;
	}

	private setPrerenderReady(): void {
		window.prerenderReady = true;
		this.shouldUpdatePrerender = false;
	}
}
